import React, { Component } from 'react';
import { FormGroup, Row, Col, FormControl } from 'react-bootstrap';
import moment from 'moment';
import 'react-day-picker/lib/style.css';
import DatePicker from 'react-mobile-datepicker';
import 'src/css/MonthlyReport.css'

class DatePikerForm extends Component {

  constructor() {
    super();
    this.state ={
      isOpen: false
    }

    this.handleSelect = this.handleSelect.bind(this);
  }

  componentWillMount() {
    this.setDate();
    this.setMinDate();
    this.setMaxDate();
  }

  componentDidUpdate(prevProps) {
    if (this.props.englishDate !== prevProps.englishDate) {
      this.setDate();
    }
    if (this.props.minDate !== prevProps.minDate) {
      this.setMinDate();
    }
    if (this.props.maxDate !== prevProps.maxDate) {
      this.setMaxDate();
    }
  }

  setDate = () => {
    let date;
    if(this.props.isDate){
      if(this.props.englishDate){
        date = this.createDate(this.props.englishDate);
      }
    }else{
      if(this.props.year && this.props.month){
        date = new Date(this.props.year, this.props.month - 1);
      }
    }
		this.setState({ date: date});
  }

  setMinDate = () => {
    if(this.props.minDate){
      this.setState({ minDate: this.createDate(this.props.minDate)});
    }
  }

  setMaxDate = () => {
    if(this.props.maxDate){
      this.setState({ maxDate: this.createDate(this.props.maxDate)});
    }
  }
  
  createDate = (stringDate) => {
    let splitDate = stringDate.split('/');
    return new Date(splitDate[2], splitDate[1] - 1, splitDate[0]);
  }

  handleClick = () => {
		this.setState({ isOpen: true});
	}

	handleCancel = () => {
		this.setState({ isOpen: false });
	}

	handleSelect = (date) => {
    let showDate = moment(date);

    this.setState({
      isOpen: false,
      date: date
    });
    this.props.selectDate(showDate);
	}


  render() {

    let dateConfig = {
      'month': {
        format: 'MM',
        caption: 'Mon',
        step: 1,
      },
      'year': {
          format: 'YYYY',
          caption: 'Year',
          step: 1,
      },
    };
    if (this.props.isDate) {
      const date = {
        'date': {
          format: 'DD',
          caption: 'Day',
          step: 1,
        }
      };
      dateConfig = Object.assign(date, dateConfig);
    }

    return (
      <div className="selectDate">
        <Row>
          <Col md={12} sm={12} xs={12}>
            <FormGroup>
              <FormControl className='form-color' type="text" value={moment(this.state.date).format(this.props.isDate ? "DD/MM/YYYY" : "MM/YYYY")} readOnly onClick={this.handleClick} />
            </FormGroup>
          </Col>
        </Row>
				<DatePicker dateConfig={dateConfig}
					value={this.state.date}
          isOpen={this.state.isOpen}
          min={this.state.minDate}
          max={this.state.maxDate}
          confirmText="OK"
          cancelText="Cancel"
          headerFormat={this.props.isDate ? "DD/MM/YYYY" : "MM/YYYY"}
					onSelect={this.handleSelect}
					onCancel={this.handleCancel} />
			</div>
    )
  }
}

export default DatePikerForm;



// WEBPACK FOOTER //
// ./src/component/Util/DatePikerForm.js